import { InsuranceType } from '@/pages/members/constants/insurance';

export const insuranceTypeLabel = ({
  label,
  jurisdiction
}: {
  label: string;
  jurisdiction: string;
}) => {
  if (jurisdiction === 'Arizona' && label === InsuranceType.MEDICAID) {
    return 'AHCCCS';
  }

  return label;
};
